<template>
  <nav
    class="fixed w-full z-20 top-0 border-b bg-[#1b2a37] h-16 flex items-center text-[#fefefe]"
  >
    <div
      class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto py-2 px-6"
    >
      <a
        href="https://flowbite.com/"
        class="flex items-center space-x-3 mx-8 rtl:space-x-reverse"
      >
        <img :src="logo" class="h-14" alt="Flowbite Logo" />
      </a>

      <div
        class="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
        id="navbar-sticky"
      >
        <ul
          class="flex flex-col p-4 md:p-0 mt-4 font-medium border border-default rounded-base bg-neutral-secondary-soft md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-neutral-primary"
        >
          <li>
            <router-link
              class="block py-2 px-3 text-white bg-brand rounded-sm md:bg-transparent md:text-fg-brand md:p-0 uppercase"
              aria-current="page"
              :to="{ name: 'home' }"
            >
              inicio
            </router-link>
          </li>

          <li>
            <!-- <a
              href="#"
              class="block py-2 px-3 text-heading rounded hover:bg-neutral-tertiary md:hover:bg-transparent md:border-0 md:hover:text-fg-brand md:p-0 md:dark:hover:bg-transparent uppercase"
              >empresas</a
            > -->
            <router-link
              class="block py-2 px-3 text-white bg-brand rounded-sm md:bg-transparent md:text-fg-brand md:p-0 uppercase"
              aria-current="page"
              :to="{ name: 'about' }"
            >
              empresas
            </router-link>
          </li>

          <li>
            <!-- <a
              href="#"
              class="block py-2 px-3 text-heading rounded hover:bg-neutral-tertiary md:hover:bg-transparent md:border-0 md:hover:text-fg-brand md:p-0 md:dark:hover:bg-transparent uppercase"
              >empresas</a
            > -->
            <router-link
              class="block py-2 px-3 text-white bg-brand rounded-sm md:bg-transparent md:text-fg-brand md:p-0 uppercase"
              aria-current="page"
              :to="{ name: 'about' }"
            >
              sobre
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { onMounted } from "vue";
import { initFlowbite } from "flowbite";
import logo from "@/assets/company/x-solution-mind-logo-rb.png";

onMounted(() => {
  initFlowbite();
});
</script>
